import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "../../context/LangContext";

export default function STRStrategy() {
  const { c } = useLang();
  const s = c.str;
  const goToDeals = () => {
    window.dispatchEvent(new CustomEvent("dscr-deals-filter", { detail: "Short-Term Rental" }));
    const el = document.getElementById("deals");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section id="str" className="section" style={{ background: "#08080a" }}>
      <div className="container-x" style={{ display: "grid", gridTemplateColumns: "1.05fr 0.95fr", gap: "4rem", alignItems: "center" }}>
        <div className="reveal">
          <span className="eyebrow">{s.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2rem,4.5vw,3.6rem)", margin: "1.2rem 0 1.6rem" }}>
            {s.title.pre}<span className="italic-gold">{s.title.em}</span>{s.title.post}
          </h2>
          <p className="body-text" style={{ marginBottom: "2rem" }}>{s.para}</p>
          <div style={{ display: "grid", gap: "1rem", marginBottom: "2.5rem" }}>
            {s.bullets.map((b, i) => (
              <div key={i} style={{ display: "flex", gap: "0.9rem", alignItems: "flex-start" }}>
                <span style={{ marginTop: 3, color: "var(--gold)", flexShrink: 0 }}><Check size={16} /></span>
                <span className="body-text" style={{ color: "var(--text)", fontSize: "0.95rem" }}>{b}</span>
              </div>
            ))}
          </div>
          <button data-testid="str-deals-cta" onClick={goToDeals} className="btn-gold">{s.cta} <ArrowRight size={15} /></button>
        </div>

        <div className="card reveal" style={{ padding: "2.5rem", background: "linear-gradient(180deg, rgba(201,162,75,0.05), rgba(255,255,255,0.01))" }}>
          <div className="eyebrow" style={{ color: "var(--muted-2)", marginBottom: "2rem" }}>{s.eyebrow}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "1rem" }}>
            {s.stats.map(([v, l], i) => {
              const hl = i === 0;
              return (
                <div key={i} style={{ padding: "1.4rem 0.8rem", textAlign: "center", border: `1px solid ${hl ? "var(--gold)" : "rgba(255,255,255,0.08)"}`, borderRadius: 3, background: hl ? "var(--gold-soft)" : "transparent" }}>
                  <div className="font-serif" style={{ fontSize: "1.7rem", color: hl ? "var(--gold)" : "var(--text)" }}>{v}</div>
                  <div style={{ fontSize: "0.64rem", letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--muted-2)", marginTop: "0.5rem", lineHeight: 1.4 }}>{l}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
